import axios from "axios";
import {
  URI_AUTH_LOGIN,
  URI_AUTH_REGISTRATION,
  URI_AUTH_RESET_PASSWORD,
  URI_AUTH_SET_NEW_PASSWORD,
} from "../helpers/constans";
import {
  ILoginPayload,
  ILoginResponseOk,
  IRegistrationPayload,
  IRegistrationResponseOk,
  IResetPasswordPayload,
  IResetPasswordResponseOk,
  ISetNewPasswordPayload,
  ISetNewPasswordResponseOk,
} from "../types/@auth";

export const fetchLogin = (
  payload: ILoginPayload
): Promise<ILoginResponseOk> => {
  return axios.post(URI_AUTH_LOGIN, payload);
};

export const fetchRegistration = (
  payload: IRegistrationPayload
): Promise<IRegistrationResponseOk> => {
  return axios.post(URI_AUTH_REGISTRATION, payload);
};

export const fetchResetPassword = (
  payload: IResetPasswordPayload
): Promise<IResetPasswordResponseOk> => {
  return axios.post(URI_AUTH_RESET_PASSWORD, payload);
};

export const fetchSetNewPassword = (
  payload: ISetNewPasswordPayload
): Promise<ISetNewPasswordResponseOk> => {
  return axios.post(URI_AUTH_SET_NEW_PASSWORD, payload);
};
